interface SwapSuccessData {
  inputAmount: number;
  outputAmount: number;
  inputToken: string;
  outputToken: string;
  inputMint: string;
  outputMint: string;
  transactionId: string;
}

interface SwapErrorData {
  errorMessage: string;
  inputToken?: string;
  outputToken?: string;
}

class Analytics {
  private static sendEvent(eventName: string, eventData: Record<string, any>) {
    if (typeof window === 'undefined' || !window.gtag) return;

    window.gtag('event', eventName, {
      event_category: 'Jupiter',
      ...eventData,
    });
  }

  static trackSwapSuccess({
    inputAmount,
    outputAmount,
    inputToken,
    outputToken,
    inputMint,
    outputMint,
    transactionId,
  }: SwapSuccessData) {
    this.sendEvent('jupiter_swap_success', {
      event_label: `${inputToken} to ${outputToken}`,
      value: inputAmount,
      input_amount: inputAmount,
      output_amount: outputAmount,
      input_token: inputToken,
      output_token: outputToken,
      input_mint: inputMint,
      output_mint: outputMint,
      transaction_id: transactionId,
    });
  }

  static trackSwapError({ errorMessage, inputToken, outputToken }: SwapErrorData) {
    this.sendEvent('jupiter_swap_error', {
      event_label: inputToken && outputToken ? `${inputToken} to ${outputToken}` : 'Swap Error',
      error_message: errorMessage,
      ...(inputToken && { input_token: inputToken }),
      ...(outputToken && { output_token: outputToken }),
    });
  }

  static trackInitError(error: unknown) {
    this.sendEvent('jupiter_init_error', {
      event_label: 'Initialization Error',
      error_message: error instanceof Error ? error.message : 'Unknown error',
    });
  }
}

export default Analytics;
